class CustomProductMeta extends ProductMeta {
    _onVariantChanged(event) {
        super._onVariantChanged(event);
        
        this._fetchAndUseVariantMetafields(event.detail.variant.id, 'description');
    }
  
    async _fetchAndUseVariantMetafields( variantId, namespace) {
        const metafields = await fetchVariantMetafields( variantId, namespace);
        if (metafields) {
          this._updateMetafields(metafields);
        }
    }

    _updateMetafields(metafields) {
        const metafieldsContainer = this.querySelector(".product-form__text_custom");
      
      
        if (metafieldsContainer) {
          const metaData = metafields.length > 0 ? JSON.parse(metafields) : [];
          metafieldsContainer.innerHTML = this.createList(metaData);

        }
    }

     createList(json) {
            if (json.type === 'root' || json.type === 'list') {
                var ul = '<ul>';
                json.children.forEach(child1 => {
                  child1.children.forEach(child => {
                      if (child.type === 'list-item') {
                          child.children.forEach(textNode => {
                              if (textNode.type === 'text') {
                                  ul += '<li>';
                                  ul += textNode.value;
                                  ul += '</li>';
                              }
                          });
                      }
                  });
                });
              ul += '</ul>';
              return ul;
            }else{
              return '';
            }
        }

}

// Register the custom element
window.customElements.define("custom-product-meta", CustomProductMeta);

const storefrontAccessToken = '53ccb937d0333bdd611d02f8e4c76194';
const storefrontApiUrl = `https://${window.location.hostname}/api/2023-07/graphql.json`;

async function fetchVariantMetafields(variantId, namespace) {
  const globalId = "gid://shopify/ProductVariant/" +variantId;
  const query = `
    {
      node(id: "${globalId}") {
        ... on ProductVariant {
          id
          title
          metafield(key: "${namespace}", namespace: "custom") {
            value
            id
          }
        }
      }
    }
  `;

  const response = await fetch(storefrontApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
    },
    body: JSON.stringify({
      query: query,
      variables: {
        "id": globalId,
        namespace: namespace
      }
    }),
  });

  

  const result = await response.json();
  const variant = result?.data?.node?.metafield?.value ?? [];

  console.log("variant", variant);
  return variant ? variant : [];
}
